import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
// import { EventEmitter } from 'protractor';
import { SweetMessage } from '../../../config/sweet-message';
import { Validation } from '../../../config/validation';
import { CostoVenta } from '../../../models/costo-venta';
import { PrecioVenta } from '../../../models/precio-venta';
import { Producto } from '../../../models/producto';
import { TipoPrecio } from '../../../models/tipo_precio';
import { ImpuestoPorcentajeService } from '../../../services/impuesto-porcentaje.service';
import { ParametroService } from '../../../services/parametro.service';
import { PrecioAdicionalService } from '../../../services/precio-adicional.service';
import { ProductoService } from '../../../services/producto.service';
import { SessionService } from '../../../services/session.service';
import { TipoPrecioService } from '../../../services/tipo-precio.service';
import { UtilsService } from '../../../services/utils.service';
import { PrecioAdicionalModalComponent } from '../precio-adicional-modal/precio-adicional-modal.component';

@Component({
  selector: 'app-precio-edit-modal',
  templateUrl: './precio-edit-modal.component.html',
  styleUrls: ['./precio-edit-modal.component.css'],
  providers: [ProductoService, SessionService, ParametroService,PrecioAdicionalService,ImpuestoPorcentajeService, TipoPrecioService]
})
export class PrecioEditModalComponent implements OnInit {
  @Input() producto_id: number;
  @Output() sendProducto = new EventEmitter<any>();
  public producto: Producto;
  public loading: boolean;
  myForm: FormGroup;
  public precio_venta: number;
  public precio_costo: number;
  public incluye_iva: boolean;
  public vl: Validation;
  public costos: Array<CostoVenta>;
  public precios: Array<PrecioVenta>;
  public adicionales: Array<any>;
  public tipos: Array<TipoPrecio>;
  public msgSweet: SweetMessage;
  
  public is_precios: boolean;
  public numero_decimales: number;
  public format_decimal: String;
  public is_editable: boolean;
  public tipos_id: Array<number>;
  public impuesto_porcentaje_iva: Array<any>;
  
  constructor(
    private productoService: ProductoService,
    private storage: AsyncLocalStorage,
    public ss: SessionService,
    private modalService: BsModalService,
    private bsModalRef: BsModalRef,
    public bsModalRef2: BsModalRef,
    private parametroService: ParametroService,
    public pAdicionalService: PrecioAdicionalService,
    private impuestoPorcentajeService: ImpuestoPorcentajeService,
    public tipoprecioService: TipoPrecioService,
    public utils: UtilsService,
    private fb: FormBuilder,
  ) { 
    this.producto = new Producto();
    this.precio_venta = 0;

    this.incluye_iva = false;
    this.precio_costo = 0;
    this.costos = [];
    this.precios = [];
    this.adicionales = [];
    this.tipos_id = [];
    this.impuesto_porcentaje_iva = [];
    this.tipos = [];
    this.msgSweet = new SweetMessage();
    this.vl = new Validation();
    this.is_precios = false;
    this.is_editable = false;

    this.numero_decimales = 2;
    this.format_decimal = "0,0.00";

    this.loading = false;

  }

  ngOnInit() {
    this.loading = true;
    this.onForm();
    let p1 = this.getParamNumeroDecimales();
    let p2 = this.getPreciosAdicionales();
    let p3 = this.getProductoPrecio();
    let p4 = this.getPrecios();
    
    let p5;
    if (this.producto.impuesto_iva_id != '0') {
      p5 = this.getImpuestoPorcentaje(2);
    }

    // let p6 = this.getTipos();
    
    Promise.all([p1, p2,p3,p4,p5]).then(
      res => this.loading = false,
      err => this.loading = false
    );
    this.setValueForm();
  }
  getImpuestoPorcentaje(impuesto_id) {
		let qs = "?impuesto_id=" + impuesto_id + "&is_tarifa=1&is_vigente=1";
		return new Promise((resolve, reject) => {
			this.impuestoPorcentajeService.getAll(qs).subscribe(
				res => {
					this.impuesto_porcentaje_iva = res.data;



					resolve(true);
				}, err => {
					this.impuesto_porcentaje_iva = [];
					reject();
				}
			);
		});
	}

  onForm() {
		this.myForm = this.fb.group({
			
			iva: ['', [Validators.required]],
		
			incluye_iva: [''],
		
		});

	}

  setValueForm() {
		this.myForm.setValue({
			incluye_iva: false,
	
			iva: (this.producto.impuesto_iva_id != '' || this.producto.graba_iva) ? this.producto.impuesto_iva_id : this.producto.impuesto_iva_id = '128',			// incluye_iva: this.producto.incluye_iva,

		});
	
  }
  
  validErrorForm(campo) {
		return this.vl.validErrorForm(campo, this.myForm);
	}

	validTypeMsgForm(nombre, campo) {
		return this.vl.validTypeMsgForm(nombre, campo, this.myForm);
	}

  activeIncluyeIva(incluyeIva) {
		// this.myForm.controls['incluye_iva'].value;
		if (incluyeIva._checked ) {
			this.myForm.controls['iva'].setValue(129);
			this.myForm.controls['incluye_iva'].setValue(incluyeIva._checked);
		} else {

			this.myForm.controls['iva'].setValue("");
			this.myForm.controls['incluye_iva'].setValue(false);

		}
	}

  getProductoPrecio(){
    return new Promise((resolve, reject) => {
      this.productoService.getById(this.producto_id,"?embed=categoria,unidadmedida,precios,costos").subscribe(
        res => {
          this.producto = res;
          if (this.producto.precios.length > 0) {
            this.precio_venta = parseFloat(this.producto.precios[0].precio.toString());
          }

          if (this.producto.costos.length > 0) {
              this.precio_costo = parseFloat(this.producto.costos[0].precio.toString());
          }
        
          resolve(true);
        },
        err => {
          this.producto = new Producto();
          reject();
        }
      );
    });
  }

  getPreciosAdicionales() {
    // VALORES RESPONSE: SI, NO
    return new Promise((resolve, reject) => {
        let precio_adicional_id = 16;
        this.parametroService.getById(precio_adicional_id).subscribe(
            res => {
                this.is_precios = (res.valor.toString().trim() === "SI");
                resolve(true);
            },
            err => {
                this.is_precios = false;
                reject(err);
            }
        );
    });
  }

  onSubmit() {
    this.setValueEntity();
    this.loading = true;
    this.productoService.PrecioCosto(this.producto).subscribe(
        res => {
            this.loading = false;
           
            this.getPrecios();
            this.getTipos();
            this.sendProducto.emit(true);
            this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente');
        },
        err => {
            this.loading = false;
            this.adicionales.forEach(adicional=>{
              adicional.editar = false;
            });
            this.msgSweet.showMessage('error-message', err);
        }
    );

  }

  setValueEntity() {

    let costo = new CostoVenta();
    costo.precio = this.precio_costo.toString();
    costo.producto_id = this.producto.id;
    costo.empresa_id = this.ss.getData('empresa_id');
    costo.usuario_id = this.ss.getData('usuario_id');
    this.costos.push(costo);

    this.producto.costos = this.costos;

    let precio = new PrecioVenta();
    precio.precio = this.precio_venta.toString();
    precio.incluye_iva =this.incluye_iva;

    precio.producto_id = this.producto.id;
    precio.empresa_id = this.ss.getData('empresa_id');
    precio.usuario_id = this.ss.getData('usuario_id');

    this.precios=[];
    this.precios.push(precio);
    this.producto.precio = this.precio_venta.toString();
		this.producto.costo = this.precio_costo.toString();
    this.producto.precios = this.precios;
    this.producto.preciosAdd = this.adicionales;
    this.producto.impuesto_iva_id = this.myForm.controls['iva'].value;
    let resp = this.impuesto_porcentaje_iva.filter(i=>i.id == this.producto.impuesto_iva_id);
		let porcentaje = resp[0]?parseInt(resp[0].porcentaje):null;
    porcentaje > 0?this.producto.graba_iva = true:this.producto.graba_iva = false;
    this.producto.incluye_iva = this.myForm.controls['incluye_iva'].value;
}

  // onPreciosAdicionales() {
  //   this.tipos_id = [];
  //   this.adicionales.forEach( (adicional:any) => {
  //     this.tipos_id.push(adicional.tipo_precio.id);
  //   });
  //   let tipos_id = this.tipos_id.join(",");
  //   const initialState = { producto: this.producto, tipos_id: tipos_id,numero_decimales: this.numero_decimales };
  //   this.bsModalRef = this.modalService.show(PrecioAdicionalModalComponent, Object.assign({ backdrop: 'static' }, { initialState }));

  //   this.bsModalRef.content.sendPrecioAdicional.take(1).subscribe(precio => {
  //     
  //     this.adicionales.push(precio);

  //   });
  // }

  addPrecio(){

    
    this.getTipos().then(
      res => {
        if( this.tipos.length > 0 ){
          this.adicionales.push(new TipoPrecio());
        }
      }, err => {

      }
    );
    
		
  }

  onChangeTipo(event,adicional){
    adicional.tipo_precio = new TipoPrecio();
    let tipo = this.tipos.filter(tipo=>{
      if(event.target.value == tipo.id ){
        return true;
      }
    });
    adicional.tipo_precio = tipo[0];
    this.getTipos();
  }


  
  getTipos(){
		return new Promise((resolve, reject) => {
      this.tipos_id = [];
      this.adicionales.forEach( (adicional:any) => {
        this.tipos_id.push(adicional.tipo_precio_id);
      });
      let tipos_id = this.tipos_id.join(",");
     
			this.tipoprecioService.getAll("?notin[id]=" + tipos_id).subscribe(
				res => {
					this.tipos = res.data;
					resolve(true);
				},
				err => {
					reject(err);
				}
			);
		});
	}

  getParamNumeroDecimales() {
    return new Promise((resolve, reject) => {
        let numero_decimales = 19;
        this.parametroService.getById(numero_decimales).subscribe(
            res => {
                this.numero_decimales = res.valor;

                let digitos = "";
                for (let i = 0; i < this.numero_decimales; i++) digitos += "0";
                this.format_decimal = "0,0." + digitos;
                resolve(true);
            },
            err => {
                this.numero_decimales = 2;
                this.format_decimal = "0,0.00"
                reject(err);
            }
        );
    });
  }

  getPrecios(){
		return new Promise((resolve, reject) => {
			let qs = "?producto_id="+ this.producto_id+"&status=A&embed=tipoPrecio";
			this.pAdicionalService.getAll(qs).subscribe(
				res => {
          this.adicionales = res.data;
          this.adicionales.forEach((adicional:any)=>{
            adicional.valor = this.utils.redondear(adicional.valor, 2);
          });

          this.getTipos();
					resolve(true);
				},
				err => {
					this.adicionales = [];
					reject(err);
				}
			);
		});
  }
  
  onEditar(adicional){
		adicional.editar = !adicional.editar;
		this.is_editable = !this.is_editable;
	
	}

	onEliminar(id){
		this.loading = true;
		this.pAdicionalService.delete(id).subscribe(
			res => {
				this.loading = false;
				this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente');
				this.getPrecios();
			},
			err => {
				this.loading = false;
                this.msgSweet.showMessage('error-message',err);
			}
		);
  }
  
  onDelete(i) {
    this.adicionales.splice(i, 1);
    this.getTipos();
    
  }

  isValidForm(){


    let band = true;
    this.adicionales.forEach((adicional:any)=>{
        if(adicional.tipo_precio_id == ''){
          
          band = false;
        }
        if((!adicional.valor)){
          
          band = false;
        }
       
    });

    if (!band) {
      return false;
    }

    return true;
  }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/precio-edit-modal/precio-edit-modal.component.ts